import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import "./App.css";
import { 
  CybersecurityService, 
  CloudService, 
  CablingService, 
  SurveillanceService, 
  AccessControlService,
  SmallBusinessPage,
  MidMarketPage
} from "./AdditionalPages.js";
import { 
  EnterprisePage, 
  CommercialPage, 
  PartnersPage, 
  CareersPage 
} from "./MorePages.js";
import { 
  ImageCarousel, 
  ImageGrid, 
  ProfessionalImage, 
  professionalImages 
} from "./ImageCarousel.js";
import FloatingChatWidget from "./LiveChat.js";
import AdminDashboard from "./AdminDashboard.js";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Company Data
const RTS_CONTACT = {
  company: "Riley Technology Solutions (RTS)",
  email: "johnriley1.rileytechsolutions@gmail.com",
  phone: "813.720.9057",
  website: "www.rileyts.com",
  businessType: "Veteran Owned Small Business (VOSB)",
  gsaContract: "GSA IT70 #GS35F0080V"
};

// Header Component
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center">
            <div className="text-2xl font-bold text-blue-800">RTS</div>
            <div className="ml-2 text-sm text-gray-600">Riley Technology Solutions</div>
          </Link>
          
          <nav className="hidden lg:flex space-x-8">
            <Link to="/" className="text-gray-700 hover:text-blue-800 transition duration-300">Home</Link>
            <Link to="/about" className="text-gray-700 hover:text-blue-800 transition duration-300">About Us</Link>
            <div className="relative group">
              <Link to="/services" className="text-gray-700 hover:text-blue-800 transition duration-300">Services</Link>
              <div className="absolute left-0 mt-2 w-64 bg-white shadow-lg rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300">
                <div className="p-2">
                  <Link to="/services/msp" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded">Managed Service Provider</Link>
                  <Link to="/services/cybersecurity" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded">Cybersecurity Services</Link>
                  <Link to="/services/cloud" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded">Cloud Innovation</Link>
                  <Link to="/services/cabling" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded">Network Cabling</Link>
                  <Link to="/services/surveillance" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded">IP Surveillance</Link>
                  <Link to="/services/access-control" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded">Access Control</Link>
                </div>
              </div>
            </div>
            <div className="relative group">
              <Link to="/commercial" className="text-gray-700 hover:text-blue-800 transition duration-300">Commercial</Link>
              <div className="absolute left-0 mt-2 w-64 bg-white shadow-lg rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300">
                <div className="p-2">
                  <Link to="/commercial/small-business" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded">Small Businesses</Link>
                  <Link to="/commercial/mid-market" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded">Mid-Market Businesses</Link>
                  <Link to="/commercial/enterprise" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded">Enterprise Businesses</Link>
                </div>
              </div>
            </div>
            <Link to="/federal" className="text-gray-700 hover:text-blue-800 transition duration-300">Federal</Link>
            <Link to="/partners" className="text-gray-700 hover:text-blue-800 transition duration-300">Partners</Link>
            <Link to="/careers" className="text-gray-700 hover:text-blue-800 transition duration-300">Careers</Link>
            <Link to="/contact" className="text-gray-700 hover:text-blue-800 transition duration-300">Contact</Link>
          </nav>

          <div className="hidden lg:flex items-center space-x-4">
            <Link to="/contact" className="bg-blue-800 text-white px-6 py-2 rounded-lg hover:bg-blue-900 transition duration-300">
              Get Started
            </Link>
          </div>

          <button 
            className="lg:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t">
            <nav className="flex flex-col space-y-4">
              <Link to="/" className="text-gray-700 hover:text-blue-800" onClick={() => setIsMenuOpen(false)}>Home</Link>
              <Link to="/about" className="text-gray-700 hover:text-blue-800" onClick={() => setIsMenuOpen(false)}>About Us</Link>
              <Link to="/services" className="text-gray-700 hover:text-blue-800" onClick={() => setIsMenuOpen(false)}>Services</Link>
              <Link to="/commercial" className="text-gray-700 hover:text-blue-800" onClick={() => setIsMenuOpen(false)}>Commercial</Link>
              <Link to="/federal" className="text-gray-700 hover:text-blue-800" onClick={() => setIsMenuOpen(false)}>Federal</Link>
              <Link to="/partners" className="text-gray-700 hover:text-blue-800" onClick={() => setIsMenuOpen(false)}>Partners</Link>
              <Link to="/careers" className="text-gray-700 hover:text-blue-800" onClick={() => setIsMenuOpen(false)}>Careers</Link>
              <Link to="/contact" className="text-gray-700 hover:text-blue-800" onClick={() => setIsMenuOpen(false)}>Contact</Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

// Home Page Component
const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center bg-gradient-to-r from-blue-800 to-blue-900 text-white">
        <div className="absolute inset-0 bg-black opacity-40"></div>
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1573164713988-8665fc963095?auto=format&fit=crop&w=1920&q=80)'
          }}
        ></div>
        <div className="relative z-10 text-center max-w-4xl mx-auto px-4">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Reliable Technology Solutions for Your Mission-Critical Systems
          </h1>
          <p className="text-xl md:text-2xl mb-6">
            Veteran-owned IT services company serving government and commercial clients with 30+ years of expertise
          </p>
          <div className="bg-blue-700 bg-opacity-90 p-6 rounded-lg mb-8 text-left max-w-3xl mx-auto">
            <h3 className="text-lg font-semibold mb-4 text-center">Company Capabilities Highlights</h3>
            <div className="grid md:grid-cols-2 gap-4 text-sm">
              <div>
                <p><strong>Business Type:</strong> Veteran-Owned Small Business (VOSB)</p>
                <p><strong>GSA Schedule:</strong> IT70 #GS35F0080V</p>
                <p><strong>Years in Business:</strong> 20+ Years (Founded 2002)</p>
              </div>
              <div>
                <p><strong>Security Clearances:</strong> Available</p>
                <p><strong>Service Areas:</strong> Nationwide</p>
                <p><strong>Primary NAICS:</strong> 541512 - Computer Systems Design</p>
              </div>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => navigate('/contact')}
              className="bg-orange-500 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-orange-600 transition duration-300"
            >
              Get Free Consultation
            </button>
            <button 
              onClick={() => navigate('/services')}
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-blue-800 transition duration-300"
            >
              View Our Services
            </button>
          </div>
        </div>
      </section>

      {/* Client Logos Section */}
      <section className="py-16 bg-gray-100">
        <div className="container mx-auto px-4">
          <h3 className="text-center text-gray-600 mb-8">Trusted by Government and Commercial Clients</h3>
          <div className="flex justify-center items-center space-x-8 opacity-70">
            <div className="text-2xl font-bold text-gray-500">US ARMY</div>
            <div className="text-2xl font-bold text-gray-500">VA</div>
            <div className="text-2xl font-bold text-gray-500">GSA</div>
            <div className="text-2xl font-bold text-gray-500">DOD</div>
            <div className="text-2xl font-bold text-gray-500">CBP</div>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Our IT Services & Solutions</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Comprehensive technology services designed to optimize your operations and secure your digital infrastructure
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: "Managed Service Provider (MSP)",
                description: "24/7 monitoring, proactive maintenance, and comprehensive IT support",
                icon: "🔧",
                link: "/services/msp"
              },
              {
                title: "Cybersecurity Services",
                description: "Advanced threat protection, compliance, and security monitoring",
                icon: "🛡️",
                link: "/services/cybersecurity"
              },
              {
                title: "Cloud Innovation & Strategy",
                description: "Microsoft Azure implementation and cloud transformation",
                icon: "☁️",
                link: "/services/cloud"
              },
              {
                title: "Professional IT Implementation",
                description: "Expert project management and system integration",
                icon: "⚙️",
                link: "/services"
              },
              {
                title: "Federal Government Services",
                description: "Security clearance and compliance for government agencies",
                icon: "🏛️",
                link: "/federal"
              },
              {
                title: "Infrastructure Solutions",
                description: "Cabling, surveillance, and access control systems",
                icon: "🏗️",
                link: "/services/cabling"
              }
            ].map((service, index) => (
              <div key={index} className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition duration-300">
                <div className="text-4xl mb-4">{service.icon}</div>
                <h3 className="text-xl font-semibold mb-4 text-gray-800">{service.title}</h3>
                <p className="text-gray-600 mb-6">{service.description}</p>
                <button 
                  onClick={() => navigate(service.link)}
                  className="text-blue-800 font-semibold hover:text-blue-900 transition duration-300"
                >
                  Learn More →
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose RTS */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-800 mb-6">Why Choose Riley Technology Solutions?</h2>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="bg-blue-800 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-4 mt-1">
                    ✓
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800 mb-2">Veteran Owned Small Business</h4>
                    <p className="text-gray-600">Supporting the veteran community with integrity and excellence</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="bg-blue-800 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-4 mt-1">
                    ✓
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800 mb-2">30+ Years Experience</h4>
                    <p className="text-gray-600">Decades of proven success in complex technology implementations</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="bg-blue-800 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-4 mt-1">
                    ✓
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800 mb-2">GSA Contract Holder</h4>
                    <p className="text-gray-600">GSA IT70 #GS35F0080V - Streamlined government procurement</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="bg-blue-800 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-4 mt-1">
                    ✓
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800 mb-2">Mission-Critical Focus</h4>
                    <p className="text-gray-600">Understanding unique requirements for high-visibility systems</p>
                  </div>
                </div>
              </div>
              <button 
                onClick={() => navigate('/about')}
                className="mt-8 bg-blue-800 text-white px-8 py-3 rounded-lg hover:bg-blue-900 transition duration-300"
              >
                Learn More About RTS
              </button>
            </div>
            <div>
              <ImageCarousel 
                images={professionalImages.corporate} 
                autoPlay={true} 
                interval={7000}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-blue-800 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-6">Ready to Transform Your IT Infrastructure?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Get a free consultation to discuss how RTS can optimize your technology operations and enhance security
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => navigate('/contact')}
              className="bg-orange-500 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-orange-600 transition duration-300"
            >
              Schedule Free Consultation
            </button>
            <a 
              href={`tel:${RTS_CONTACT.phone}`}
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-blue-800 transition duration-300"
            >
              Call {RTS_CONTACT.phone}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

// About Page Component
const About = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-blue-800 to-blue-900 text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-6">About Riley Technology Solutions</h1>
          <p className="text-xl max-w-3xl mx-auto">
            A Veteran Owned Small Business delivering innovative technology solutions with integrity, excellence, and unwavering commitment to client success
          </p>
        </div>
      </section>

      {/* Corporate Overview */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-800 mb-6">Corporate Overview</h2>
              <div className="space-y-4 text-lg text-gray-600">
                <p>Founded as a business enterprise in 2002</p>
                <p>Certified by SBA as a Veteran Small Business Owner (VOSB)</p>
                <p>Established proven reputation for excellence in service and integrity</p>
                <p>Successful record of adapting to new IT technologies and market environments</p>
                <p>Managed Solution Provider (MSP) for mission critical IT and telecom infrastructure requirements</p>
              </div>
              <div className="bg-blue-50 p-6 rounded-lg mt-8">
                <h3 className="text-lg font-semibold text-blue-800 mb-2">GSA Contract Holder</h3>
                <p className="text-blue-700">GSA IT70 #GS35F0080V</p>
                <p className="text-sm text-blue-600 mt-2">Streamlined procurement for government agencies</p>
              </div>
            </div>
            <div>
              <img 
                src="https://images.unsplash.com/photo-1557426272-fc759fdf7a8d?auto=format&fit=crop&w=800&q=80"
                alt="Professional working at computer" 
                className="rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Company Capabilities Statement */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Company Capabilities Statement</h2>
            <p className="text-xl text-gray-600">Comprehensive business profile and qualifications</p>
          </div>

          {/* Professional Image Carousel */}
          <div className="mb-16">
            <ImageCarousel 
              images={professionalImages.team} 
              autoPlay={true} 
              interval={6000}
            />
          </div>
          
          <div className="grid lg:grid-cols-3 gap-8 mb-12">{/* Rest of capabilities content stays the same */}
            {/* Business Information */}
            <div className="bg-white p-8 rounded-lg shadow-lg">
              <h3 className="text-xl font-bold text-gray-800 mb-6">Business Information</h3>
              <div className="space-y-4 text-sm">
                <div>
                  <span className="font-semibold text-gray-700">Company Name:</span>
                  <p>Riley Technology Solutions, LLC</p>
                </div>
                <div>
                  <span className="font-semibold text-gray-700">Business Type:</span>
                  <p>Veteran-Owned Small Business (VOSB)</p>
                </div>
                <div>
                  <span className="font-semibold text-gray-700">Year Established:</span>
                  <p>2002</p>
                </div>
                <div>
                  <span className="font-semibold text-gray-700">Primary Contact:</span>
                  <p>John Riley, CEO</p>
                </div>
                <div>
                  <span className="font-semibold text-gray-700">Email:</span>
                  <p>johnriley1.rileytechsolutions@gmail.com</p>
                </div>
                <div>
                  <span className="font-semibold text-gray-700">Phone:</span>
                  <p>813.720.9057</p>
                </div>
                <div>
                  <span className="font-semibold text-gray-700">Website:</span>
                  <p>www.rileyts.com</p>
                </div>
              </div>
            </div>

            {/* Certifications & Registrations */}
            <div className="bg-white p-8 rounded-lg shadow-lg">
              <h3 className="text-xl font-bold text-gray-800 mb-6">Certifications & Registrations</h3>
              <div className="space-y-4 text-sm">
                <div>
                  <span className="font-semibold text-gray-700">SBA Certification:</span>
                  <p>Veteran-Owned Small Business (VOSB)</p>
                </div>
                <div>
                  <span className="font-semibold text-gray-700">GSA Schedule:</span>
                  <p>IT70 #GS35F0080V</p>
                </div>
                <div>
                  <span className="font-semibold text-gray-700">Primary NAICS:</span>
                  <p>541512 - Computer Systems Design Services</p>
                </div>
                <div>
                  <span className="font-semibold text-gray-700">Additional NAICS:</span>
                  <div className="ml-4 space-y-1">
                    <p>• 541511 - Custom Computer Programming</p>
                    <p>• 541513 - Computer Facilities Management</p>
                    <p>• 541519 - Other Computer Related Services</p>
                    <p>• 238210 - Electrical Contractors</p>
                  </div>
                </div>
                <div>
                  <span className="font-semibold text-gray-700">Size Standard:</span>
                  <p>Small Business</p>
                </div>
                <div>
                  <span className="font-semibold text-gray-700">Service Areas:</span>
                  <p>Nationwide (Primary: Florida)</p>
                </div>
              </div>
            </div>

            {/* Core Competencies */}
            <div className="bg-white p-8 rounded-lg shadow-lg">
              <h3 className="text-xl font-bold text-gray-800 mb-6">Core Competencies</h3>
              <div className="space-y-4 text-sm">
                <div>
                  <span className="font-semibold text-gray-700">IT Professional Services:</span>
                  <div className="ml-4 space-y-1 mt-2">
                    <p>• Systems Integration & Implementation</p>
                    <p>• Network Design & Management</p>
                    <p>• Cybersecurity Solutions</p>
                    <p>• Cloud Computing Services</p>
                    <p>• Help Desk & Technical Support</p>
                  </div>
                </div>
                <div>
                  <span className="font-semibold text-gray-700">Infrastructure Services:</span>
                  <div className="ml-4 space-y-1 mt-2">
                    <p>• Structured Cabling Systems</p>
                    <p>• Fiber Optic Installation</p>
                    <p>• Wireless Network Solutions</p>
                    <p>• Data Center Services</p>
                  </div>
                </div>
                <div>
                  <span className="font-semibold text-gray-700">Security Solutions:</span>
                  <div className="ml-4 space-y-1 mt-2">
                    <p>• IP Surveillance Systems</p>
                    <p>• Access Control Systems</p>
                    <p>• Physical Security Integration</p>
                    <p>• Security Consulting</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Past Performance & Key Differentiators */}
          <div className="grid lg:grid-cols-2 gap-12 mt-12">
            <div className="bg-white p-8 rounded-lg shadow-lg">
              <h3 className="text-2xl font-bold text-gray-800 mb-6">Past Performance Highlights</h3>
              <div className="space-y-6">
                <div>
                  <h4 className="font-semibold text-gray-700 mb-2">Government Clients Served:</h4>
                  <div className="text-sm text-gray-600 space-y-1">
                    <p>• US Army, Navy & Air Force installations</p>
                    <p>• Veterans Affairs Medical Centers</p>
                    <p>• Small Business Administration offices</p>
                    <p>• US Customs & Border Protection</p>
                    <p>• Environmental Protection Agency</p>
                    <p>• Social Security Administration</p>
                    <p>• Nuclear Regulatory Commission</p>
                    <p>• Department of Transportation</p>
                  </div>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-700 mb-2">Project Types:</h4>
                  <div className="text-sm text-gray-600 space-y-1">
                    <p>• Mission-critical system implementations</p>
                    <p>• Federal IT modernization projects</p>
                    <p>• Cybersecurity infrastructure upgrades</p>
                    <p>• Cloud migration and optimization</p>
                    <p>• Network infrastructure overhauls</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-lg">
              <h3 className="text-2xl font-bold text-gray-800 mb-6">Key Differentiators</h3>
              <div className="space-y-6">
                <div>
                  <h4 className="font-semibold text-gray-700 mb-2">Veteran Leadership:</h4>
                  <p className="text-sm text-gray-600">Military-trained leadership with understanding of government operations and security requirements</p>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-700 mb-2">Security Clearance Capability:</h4>
                  <p className="text-sm text-gray-600">Team members with appropriate security clearances for sensitive government projects</p>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-700 mb-2">Mission-Critical Focus:</h4>
                  <p className="text-sm text-gray-600">Specialized experience with high-visibility, mission-critical systems requiring 24/7 availability</p>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-700 mb-2">Partnership Network:</h4>
                  <p className="text-sm text-gray-600">Strategic partnerships with 100+ certified small and disadvantaged businesses nationwide</p>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-700 mb-2">Industry Certifications:</h4>
                  <p className="text-sm text-gray-600">Team holds CompTIA, Cisco, Microsoft, and other industry-leading certifications</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contract Vehicles & Competitive Advantages */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Contract Vehicles & Competitive Advantages</h2>
            <p className="text-xl text-gray-600">Streamlined procurement and exceptional service delivery</p>
          </div>

          {/* Professional Office Images */}
          <div className="mb-12">
            <ImageGrid images={professionalImages.office} columns={2} />
          </div>
          
          <div className="grid lg:grid-cols-2 gap-12 mb-12">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-lg">
              <h3 className="text-2xl font-bold text-blue-800 mb-6">Contract Vehicles</h3>
              <div className="space-y-4">
                <div className="bg-white p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-800 mb-2">GSA Multiple Award Schedule (MAS)</h4>
                  <p className="text-sm text-gray-600 mb-2">Contract Number: GS35F0080V</p>
                  <p className="text-sm text-gray-600">IT Professional Services (IT70)</p>
                </div>
                <div className="bg-white p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-800 mb-2">Available for IDIQ Contracts</h4>
                  <p className="text-sm text-gray-600">Indefinite Delivery/Indefinite Quantity contracts for ongoing services</p>
                </div>
                <div className="bg-white p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-800 mb-2">Subcontracting Opportunities</h4>
                  <p className="text-sm text-gray-600">Prime contractor partnerships and subcontracting arrangements</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-green-100 p-8 rounded-lg">
              <h3 className="text-2xl font-bold text-green-800 mb-6">Competitive Advantages</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <span className="text-green-600 mr-3 mt-1">✓</span>
                  <div>
                    <h4 className="font-semibold text-gray-800">Veteran-Owned Advantage</h4>
                    <p className="text-sm text-gray-600">VOSB certification provides federal contracting preferences</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <span className="text-green-600 mr-3 mt-1">✓</span>
                  <div>
                    <h4 className="font-semibold text-gray-800">Small Business Agility</h4>
                    <p className="text-sm text-gray-600">Rapid response capabilities and flexible service delivery</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <span className="text-green-600 mr-3 mt-1">✓</span>
                  <div>
                    <h4 className="font-semibold text-gray-800">Security Clearance Ready</h4>
                    <p className="text-sm text-gray-600">Personnel with active security clearances available</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <span className="text-green-600 mr-3 mt-1">✓</span>
                  <div>
                    <h4 className="font-semibold text-gray-800">Nationwide Reach</h4>
                    <p className="text-sm text-gray-600">Service delivery capabilities across all 50 states</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <span className="text-green-600 mr-3 mt-1">✓</span>
                  <div>
                    <h4 className="font-semibold text-gray-800">Mission-Critical Experience</h4>
                    <p className="text-sm text-gray-600">20+ years supporting high-visibility government systems</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Financial & Corporate Responsibility */}
          <div className="bg-white p-8 rounded-lg shadow-lg">
            <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">Financial Stability & Corporate Responsibility</h3>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">💼</span>
                </div>
                <h4 className="font-semibold text-gray-800 mb-2">Financial Stability</h4>
                <p className="text-sm text-gray-600">20+ years of consistent business operations with strong financial foundation</p>
              </div>
              <div className="text-center">
                <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">🤝</span>
                </div>
                <h4 className="font-semibold text-gray-800 mb-2">Partnership Network</h4>
                <p className="text-sm text-gray-600">Strategic alliances with 100+ certified small and disadvantaged businesses</p>
              </div>
              <div className="text-center">
                <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">🛡️</span>
                </div>
                <h4 className="font-semibold text-gray-800 mb-2">Quality Assurance</h4>
                <p className="text-sm text-gray-600">Commitment to excellence with established quality management processes</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values & Beliefs */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Our Values & Beliefs</h2>
            <p className="text-xl text-gray-600">The principles that guide everything we do</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: "Be Ambitious & Focused",
                description: "Achieve sustainable and controlled growth with ambitious goals",
                icon: "🎯"
              },
              {
                title: "Share the Rewards",
                description: "Everyone associated with RTS feels rewarded and fulfilled",
                icon: "🤝"
              },
              {
                title: "Opportunity & Growth",
                description: "People excel and grow when given opportunity and shown how",
                icon: "📈"
              },
              {
                title: "Continuous Learning",
                description: "Take on tasks you've never done before to avoid career stagnation",
                icon: "📚"
              },
              {
                title: "Customer Success",
                description: "The ultimate test is when customers give us more challenging jobs",
                icon: "⭐"
              },
              {
                title: "Effective Communication",
                description: "Be cost-effective and communicate clearly in all interactions",
                icon: "💬"
              }
            ].map((value, index) => (
              <div key={index} className="bg-white p-8 rounded-lg shadow-lg text-center">
                <div className="text-4xl mb-4">{value.icon}</div>
                <h3 className="text-xl font-semibold mb-4 text-gray-800">{value.title}</h3>
                <p className="text-gray-600">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* For Veterans Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <ProfessionalImage 
                src="https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxvZmZpY2UlMjB0ZWFtfGVufDB8fHx8MTc1NTY2Mjg0Nnww&ixlib=rb-4.1.0&q=85"
                alt="Professional team meeting and collaboration"
                caption="Veterans working together to deliver excellence"
                overlay={true}
              />
            </div>
            <div>
              <h2 className="text-4xl font-bold text-gray-800 mb-6">For Veterans</h2>
              <p className="text-lg text-gray-600 mb-6">
                RTS employs veterans at every level of the organization, from staff to senior leadership. We work side by side with the Department of Defense, Military Agencies and Veterans Affairs, providing professional services and IT solutions to solve their problems and secure our nation.
              </p>
              <p className="text-lg text-gray-600 mb-8">
                We take great pride in service to our nation and those who have served in the military, recognizing that you have the talent, character, and commitment to duty that will help make our clients' missions successful.
              </p>
              <button 
                onClick={() => navigate('/careers')}
                className="bg-blue-800 text-white px-8 py-3 rounded-lg hover:bg-blue-900 transition duration-300"
              >
                Explore Veteran Opportunities
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Industries Served */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Industries We Serve</h2>
            <p className="text-xl text-gray-600">Trusted by organizations across multiple sectors</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              "Federal Government Agencies",
              "State and Local Government",
              "Small Businesses",
              "Mid-Market Businesses",
              "Enterprise Businesses",
              "Healthcare Organizations",
              "Educational Institutions",
              "Non-Profit Organizations"
            ].map((industry, index) => (
              <div key={index} className="bg-gradient-to-br from-blue-50 to-blue-100 p-6 rounded-lg text-center">
                <h3 className="text-lg font-semibold text-blue-800">{industry}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SDB & MBE Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Small Disadvantaged Business & MBE</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              RTS maintains ongoing relationships with several companies designated as small disadvantaged business by Small Business Administration (SBA) or as Minority-owned Business Enterprises by specific states.
            </p>
          </div>
          
          <div className="bg-white p-8 rounded-lg shadow-lg max-w-4xl mx-auto">
            <p className="text-lg text-gray-700 mb-6">
              SDB companies can be Woman-Owned, Hub-Zone, 8(a), Veteran Owned Businesses or Service-Disabled Veteran Owned Small Businesses.
            </p>
            <p className="text-lg text-gray-700">
              RTS has partnered with many Certified SBEs and MBEs to provide our nationwide or State of Florida clients with responsive on-time delivery of consulting and technical services to support them.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

// Services Page Component (This will be updated in the next file)
const Services = () => {
  const [services, setServices] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await axios.get(`${API}/services`);
        setServices(response.data.services);
      } catch (error) {
        console.error('Error fetching services:', error);
      }
    };
    fetchServices();
  }, []);

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-blue-800 to-blue-900 text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-6">Our IT Services & Solutions</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Comprehensive technology services designed to optimize your operations, enhance security, and drive business growth
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12">
            {services.map((service, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition duration-300">
                <div className="p-8">
                  <div className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-semibold mb-4 inline-block">
                    {service.category}
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">{service.name}</h3>
                  <p className="text-gray-600 mb-6">{service.description}</p>
                  
                  {service.features && service.features.length > 0 && (
                    <div className="mb-6">
                      <h4 className="text-lg font-semibold text-gray-800 mb-3">Key Features:</h4>
                      <ul className="space-y-2">
                        {service.features.map((feature, featureIndex) => (
                          <li key={featureIndex} className="flex items-start">
                            <span className="text-green-500 mr-3 mt-1">✓</span>
                            <span className="text-gray-600">{feature}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  
                  <button 
                    onClick={() => navigate('/contact')}
                    className="bg-blue-800 text-white px-6 py-3 rounded-lg hover:bg-blue-900 transition duration-300"
                  >
                    Learn More
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-blue-800 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-6">Need a Custom Solution?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Our experts can design and implement tailored technology solutions to meet your specific requirements
          </p>
          <button 
            onClick={() => navigate('/contact')}
            className="bg-orange-500 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-orange-600 transition duration-300"
          >
            Discuss Your Requirements
          </button>
        </div>
      </section>
    </div>
  );
};

// MSP Service Page
const MSPService = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen">
      <section className="py-20 bg-gradient-to-r from-blue-800 to-blue-900 text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-6">Managed Service Provider (MSP)</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Engage with a Managed Services Provider (MSP) that brings proven industry experience in delivering quality solutions that meet your unique requirements!
          </p>
        </div>
      </section>

      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-800 mb-6">Why Choose RTS MSP Services?</h2>
              <p className="text-lg text-gray-600 mb-6">
                If your business relies on access to a functional internet connection and network, even a small problem with your system can pose a serious setback.
              </p>
              <p className="text-lg text-gray-600 mb-8">
                Our MSP company will find and/or develop a solution for your current business issue and provide ongoing support, so you won't have to worry about future problems.
              </p>
              
              <div className="space-y-4">
                <div className="flex items-start">
                  <span className="text-blue-800 mr-3 mt-1">🔧</span>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800">24/7 Monitoring & Support</h4>
                    <p className="text-gray-600">Continuous monitoring and immediate response to issues</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <span className="text-blue-800 mr-3 mt-1">⚡</span>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800">Proactive Maintenance</h4>
                    <p className="text-gray-600">Prevent problems before they impact your business</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <span className="text-blue-800 mr-3 mt-1">🎯</span>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800">Help Desk Support</h4>
                    <p className="text-gray-600">Expert technical support when you need it</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <div className="bg-gray-50 p-8 rounded-lg">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">MSP Services Offered</h3>
                <ul className="space-y-4">
                  {[
                    "Network monitoring and management",
                    "Help desk and technical support",
                    "Security monitoring and incident response",
                    "Backup and disaster recovery",
                    "Software updates and patch management",
                    "Hardware maintenance and replacement",
                    "Cloud services management",
                    "Compliance and reporting"
                  ].map((service, index) => (
                    <li key={index} className="flex items-start">
                      <span className="text-green-500 mr-3 mt-1">✓</span>
                      <span className="text-gray-700">{service}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-blue-800 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-6">Ready to Partner with RTS MSP?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Contact us today to learn how our MSP services can support your business operations
          </p>
          <button 
            onClick={() => navigate('/contact')}
            className="bg-orange-500 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-orange-600 transition duration-300"
          >
            Contact MSP Team
          </button>
        </div>
      </section>
    </div>
  );
};

// Add other service pages here (continuing in next part due to length)...

// Federal Services Page
const Federal = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-blue-800 to-blue-900 text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-6">Federal Government Services</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Specialized IT services for federal agencies with security clearance and compliance expertise
          </p>
          <div className="mt-8 bg-blue-700 px-6 py-3 rounded-lg inline-block">
            <span className="text-lg font-semibold">GSA Contract: IT70 #GS35F0080V</span>
          </div>
        </div>
      </section>

      {/* Federal Services */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Federal Agencies We Serve</h2>
            <p className="text-xl text-gray-600">Over 20 years serving dozens of federal departments and military agencies</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            {[
              "US Army, Navy & Air Force",
              "Veterans Affairs Medical Centers",
              "Small Business Administration",
              "General Services Administration",
              "US Customs & Border Protection",
              "Environmental Protection Agency",
              "Social Security Administration",
              "Missile Defense Agency",
              "US Geological Survey",
              "Nuclear Regulatory Commission",
              "Department of Transportation",
              "NOAA"
            ].map((agency, index) => (
              <div key={index} className="bg-gradient-to-br from-blue-50 to-blue-100 p-4 rounded-lg text-center">
                <h3 className="text-sm font-semibold text-blue-800">{agency}</h3>
              </div>
            ))}
          </div>
          
          <div className="grid lg:grid-cols-2 gap-12">
            <div>
              <h2 className="text-4xl font-bold text-gray-800 mb-6">Mission-Critical IT Support</h2>
              <p className="text-lg text-gray-600 mb-6">
                RTS understands and delivers to federal customers' unique and special business requirements for their mission-critical systems. Our customer systems are highly visible to executive management, stakeholders, citizens, and customers.
              </p>
              <p className="text-lg text-gray-600 mb-8">
                We understand the technologies and processes required to deliver the needed high availability and consistency for end users that are the key metrics for such systems support and success.
              </p>
              
              <div className="space-y-4">
                <div className="flex items-start">
                  <span className="text-blue-800 mr-3 mt-1">🏛️</span>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800">Federal Agency Experience</h4>
                    <p className="text-gray-600">Extensive experience working with various federal departments and agencies</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <span className="text-blue-800 mr-3 mt-1">🔒</span>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800">Security Clearance</h4>
                    <p className="text-gray-600">Team members with appropriate security clearances for sensitive projects</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <span className="text-blue-800 mr-3 mt-1">📋</span>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800">Compliance Expertise</h4>
                    <p className="text-gray-600">Deep understanding of federal compliance requirements and standards</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <div className="bg-gray-50 p-8 rounded-lg">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">Federal Service Offerings</h3>
                <ul className="space-y-4">
                  {[
                    "Mission-critical system support",
                    "Security clearance projects",
                    "Federal compliance management", 
                    "Secure communications solutions",
                    "Government contracting expertise",
                    "High-availability system design",
                    "Federal IT modernization",
                    "Cybersecurity for government"
                  ].map((service, index) => (
                    <li key={index} className="flex items-start">
                      <span className="text-green-500 mr-3 mt-1">✓</span>
                      <span className="text-gray-700">{service}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* GSA Information */}
      <section className="py-20 bg-blue-50">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">GSA Contract Holder</h2>
            <div className="bg-white p-8 rounded-lg shadow-lg max-w-2xl mx-auto">
              <h3 className="text-2xl font-bold text-blue-800 mb-4">GSA IT70 #GS35F0080V</h3>
              <p className="text-lg text-gray-600 mb-6">
                Our GSA contract provides federal agencies with streamlined procurement processes and pre-negotiated pricing for our IT services.
              </p>
              <div className="grid md:grid-cols-2 gap-4 text-left">
                <div>
                  <h4 className="font-semibold text-gray-800 mb-2">Benefits:</h4>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• Streamlined procurement</li>
                    <li>• Pre-negotiated pricing</li>
                    <li>• Reduced acquisition time</li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800 mb-2">Coverage:</h4>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• IT Professional Services</li>
                    <li>• System Integration</li>
                    <li>• Cybersecurity Services</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-blue-800 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-6">Ready to Partner with RTS?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Contact us to discuss your federal agency's IT requirements and how we can support your mission
          </p>
          <button 
            onClick={() => navigate('/contact')}
            className="bg-orange-500 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-orange-600 transition duration-300"
          >
            Contact Federal Services Team
          </button>
        </div>
      </section>
    </div>
  );
};

// More components continued in next file due to length limit...

// Continue with remaining components (Partners, Commercial pages, etc.) in the next file
// This is getting quite long, so I'll continue in the next bulk write

// Footer Component
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-800 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid lg:grid-cols-4 gap-8">
          <div>
            <div className="text-2xl font-bold text-blue-400 mb-4">RTS</div>
            <p className="text-gray-300 mb-4">
              Riley Technology Solutions - Your trusted partner for comprehensive IT services and solutions.
            </p>
            <div className="text-sm text-gray-400">
              <div>{RTS_CONTACT.businessType}</div>
              <div>{RTS_CONTACT.gsaContract}</div>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2 text-gray-300">
              <li><Link to="/services/msp" className="hover:text-blue-400">Managed Services</Link></li>
              <li><Link to="/services/cybersecurity" className="hover:text-blue-400">Cybersecurity</Link></li>
              <li><Link to="/services/cloud" className="hover:text-blue-400">Cloud Solutions</Link></li>
              <li><Link to="/federal" className="hover:text-blue-400">Federal Services</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Company</h3>
            <ul className="space-y-2 text-gray-300">
              <li><Link to="/about" className="hover:text-blue-400">About Us</Link></li>
              <li><Link to="/partners" className="hover:text-blue-400">Partners</Link></li>
              <li><Link to="/careers" className="hover:text-blue-400">Careers</Link></li>
              <li><Link to="/contact" className="hover:text-blue-400">Contact</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <div className="space-y-2 text-gray-300">
              <div>
                <a href={`tel:${RTS_CONTACT.phone}`} className="hover:text-blue-400">
                  {RTS_CONTACT.phone}
                </a>
              </div>
              <div>
                <a href={`mailto:${RTS_CONTACT.email}`} className="hover:text-blue-400">
                  {RTS_CONTACT.email}
                </a>
              </div>
              <div>{RTS_CONTACT.website}</div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {currentYear} Riley Technology Solutions. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

// Main App Component with Routes
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/msp" element={<MSPService />} />
          <Route path="/services/cybersecurity" element={<CybersecurityService />} />
          <Route path="/services/cloud" element={<CloudService />} />
          <Route path="/services/cabling" element={<CablingService />} />
          <Route path="/services/surveillance" element={<SurveillanceService />} />
          <Route path="/services/access-control" element={<AccessControlService />} />
          <Route path="/commercial" element={<CommercialPage />} />
          <Route path="/commercial/small-business" element={<SmallBusinessPage />} />
          <Route path="/commercial/mid-market" element={<MidMarketPage />} />
          <Route path="/commercial/enterprise" element={<EnterprisePage />} />
          <Route path="/federal" element={<Federal />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
        <Footer />
        
        {/* Enhanced Live Chat Widget */}
        <FloatingChatWidget />
      </BrowserRouter>
    </div>
  );
}

// Contact Page (keeping the existing one for now)
const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: '',
    service_interest: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      await axios.post(`${API}/contact`, formData);
      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        message: '',
        service_interest: ''
      });
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-blue-800 to-blue-900 text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-6">Contact Riley Technology Solutions</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Ready to discuss your IT needs? Get in touch with our team of experts
          </p>
        </div>
      </section>

      {/* Contact Information & Form */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Contact Information */}
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-8">Get In Touch</h2>
              
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="bg-blue-100 p-3 rounded-lg mr-4">
                    <svg className="w-6 h-6 text-blue-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-1">Phone</h3>
                    <a href={`tel:${RTS_CONTACT.phone}`} className="text-blue-800 hover:text-blue-900">
                      {RTS_CONTACT.phone}
                    </a>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="bg-blue-100 p-3 rounded-lg mr-4">
                    <svg className="w-6 h-6 text-blue-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-1">Email</h3>
                    <a href={`mailto:${RTS_CONTACT.email}`} className="text-blue-800 hover:text-blue-900">
                      {RTS_CONTACT.email}
                    </a>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="bg-blue-100 p-3 rounded-lg mr-4">
                    <svg className="w-6 h-6 text-blue-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9v-9m0-9v9" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-1">Website</h3>
                    <span className="text-blue-800">{RTS_CONTACT.website}</span>
                  </div>
                </div>
              </div>

              <div className="mt-8 p-6 bg-blue-50 rounded-lg">
                <h3 className="text-xl font-bold text-blue-800 mb-4">Business Information</h3>
                <div className="space-y-2 text-sm">
                  <div>
                    <span className="font-semibold">Business Type:</span> {RTS_CONTACT.businessType}
                  </div>
                  <div>
                    <span className="font-semibold">GSA Contract:</span> {RTS_CONTACT.gsaContract}
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-8">Send Us a Message</h2>
              
              {submitStatus === 'success' && (
                <div className="mb-6 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
                  Thank you for your message! We'll get back to you soon.
                </div>
              )}
              
              {submitStatus === 'error' && (
                <div className="mb-6 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                  There was an error sending your message. Please try again or contact us directly.
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Name *
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Email *
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Phone
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Company
                    </label>
                    <input
                      type="text"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Service Interest
                  </label>
                  <select
                    name="service_interest"
                    value={formData.service_interest}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">Select a service...</option>
                    <option value="MSP">Managed Service Provider (MSP)</option>
                    <option value="Cybersecurity">Cybersecurity Services</option>
                    <option value="Cloud">Cloud Innovation & Strategy</option>
                    <option value="Federal">Federal Government Services</option>
                    <option value="Infrastructure">Infrastructure Solutions</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Message *
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows={6}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Tell us about your IT needs and how we can help..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-blue-800 text-white py-3 px-6 rounded-lg font-semibold hover:bg-blue-900 transition duration-300 disabled:opacity-50"
                >
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default App;